// extracted by mini-css-extract-plugin
export default {"AllPrivacy":"allPrivacy_AllPrivacy__2rv0Q","title":"allPrivacy_title__7QBjA","px20":"allPrivacy_px20__iuBxu","px18":"allPrivacy_px18__o-MPW"};